import { FC } from "react";

type itemChatprops = {
  name: string;
  date: string;
  message: string;
};

type ListChatUserProps = {
  items: itemChatprops[];
};

const ListChatUser: FC<ListChatUserProps> = ({ items }) => {
  return (
    <>
      <ul role="list" className="space-y-6">
        {items?.map((item) => (
          <li className="flex flex-col">
            <span className="text-sm text-gray-400">{item.name}</span>
            <span className="text-sm text-gray-500">{item.date}</span>
            <span className="text-sm font-semibold text-gray-600">
              {item.message}
            </span>
          </li>
        ))}
      </ul>
    </>
  );
};

export default ListChatUser;
